export function validateEmail(email) {
    var re = /[a-zа-я0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zа-я0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zа-я0-9](?:[a-zа-я0-9-]*[a-zа-я0-9])?\.)+[a-zа-я0-9](?:[a-zа-я0-9-]*[a-zа-я0-9])?/;
    return re.test((email).toLowerCase());
  }